import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { GetParserErrorsResponseDto, ParserErrorDto } from '@poker-stats/contracts';

type ParserErrorsState = {
  items: ParserErrorDto[];
  total: number;
  page: number;
  pageSize: number;
  loading: boolean;
  deletingId?: number;
  error?: string;
};

const initialState: ParserErrorsState = {
  items: [],
  total: 0,
  page: 1,
  pageSize: 20,
  loading: false,
};

export const parserErrorsReducer = createSlice({
  name: 'parserErrors',
  initialState,
  reducers: {
    loadParserErrors(
      state,
      action: PayloadAction<{ page?: number; pageSize?: number } | undefined>,
    ) {
      state.page = action.payload?.page ?? state.page;
      state.pageSize = action.payload?.pageSize ?? state.pageSize;
      state.loading = true;
      state.error = undefined;
    },
    setParserErrors(state, action: PayloadAction<GetParserErrorsResponseDto>) {
      state.items = action.payload.items;
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.loading = false;
      state.error = undefined;
    },
    loadParserErrorsFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteParserError(state, action: PayloadAction<number>) {
      state.deletingId = action.payload;
    },
    deleteParserErrorFinished(state) {
      state.deletingId = undefined;
    },
  },
});

export const {
  loadParserErrors,
  setParserErrors,
  loadParserErrorsFailed,
  deleteParserError,
  deleteParserErrorFinished,
} = parserErrorsReducer.actions;
